import React, { useContext, useEffect, useState } from 'react'
import { useMutation } from '@apollo/client'
import Context from 'setup/context'
import { REQUEST_PRICE } from '../../setup/gqlQueries/priceRequestQueries'
import { FormikStyleInput as Input } from './formik/input_v2'
import Loader from './loader'
import Modal from 'pageComponents/_common/modal'
import useObjState from 'hooks/useObjState'
import styled from 'styled-components'

const ButtonRed = styled.button`
	background-color: #b51029;
	width: 120px;
	color: white;
	font-weight: 600;
	border: 0;
	box-shadow: 1px 1px 2px #000;
	margin: 4px auto;
	padding: 4px 0;
	&:hover{
		background-color: rgb(219, 22, 51);
	}
	&:active{
		background-color: #b51029;
		box-shadow: 0 0 1px #000;
	}
`

const MButton = styled.button`
    color: white;
    text-decoration: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: 'white !important';
    background: #0368e0;
    background: linear-gradient(to top left, #0368e0, #328efc);
    padding: 4px 12px;
    box-shadow: 1px 1px 2px black;
    font-size: 12px;
    font-weight: 600;
    border: none;
    margin: 5px;
    svg {
        margin-right: 5px;
    }
    &:hover {
        color: white;
        text-decoration: none;
    }
`
const MButtonNo = styled(MButton)`
    background: white;
    border: 1px solid #0368e0;
    color: black;
    &:hover {
        color: black;
        text-decoration: none;
    }
`

const FlexCol = styled.div`
    display: flex;
    gap: 5px;
    flex-direction: column;
    align-items: center;
`

const FlexRow = styled.div`
    display: flex;
    justify-content: space-around;
    width: 380px;
`

const SpanError = styled.div`
    color: #DB1633;
    font-size: 12px;
    font-weight: 500;
`

const emptyRequest = {
    firstName: '',
    lastName: null,
    companyName: null,
    email: null,
    phone: null,
}

export default function RequestPriceButton(props) {
    const { invMastUid } = props
    const context = useContext(Context)

    const [notificationMessage, setNotificationMessage] = useState(null)
    const [open, setOpen] = useState(false)
    const [request, setRequest, setRequestItem] = useObjState(emptyRequest)
    const [success, setSuccess] = useState(false)

    const [requestPrice, { loading }] = useMutation(REQUEST_PRICE, {
        variables: {
            priceRequest: {
                ...request,
                invMastUid
            }
        },
        onCompleted: data => {
            if (data.requestPrice.success === true) {
                setNotificationMessage(null)
                setSuccess(true)
            } else {
                setNotificationMessage(`${data.addWatchedProduct.message}, problem code ${data.addWatchedProduct.logId}`)
            }
        },
        onError: () => {
            setNotificationMessage("There was a problem and your price request was not submitted")
        }
    })

    const { userInfo } = context

    useEffect(() => {
        if (userInfo?.isWebUser) {
            setRequest({ invMastUid })
        }
    }, [userInfo])

    function ButtonRow() {
        return (
            <FlexRow>
                <MButton onClick={requestPrice} >Yes please!</MButton>
                <MButtonNo onClick={() => setOpen(false)}>No thanks</MButtonNo>
            </FlexRow>
        )
    }

    return (
        <div>
            <ButtonRed onClick={() => setOpen(true)}>
                Request Price
            </ButtonRed>
            {open && (
                <Modal {...{
                    open,
                    onClose: () => setOpen(false)
                }}>
                    <FlexCol>
                        {success && (
                            <>
                                <div>
                                    Your price request has been submitted.
                                </div>
                                <div>
                                    An Airline representative will be in contact.
                                </div>
                            </>
                        )}
                        {!success && userInfo?.isWebUser && (
                            <FlexCol>
                                <h4>Request Price</h4>
                                <h6 style={{ textAlign: "center" }}>
                                    Hi {context.userInfo.preferredName}, would you like to request a price for this item?
                                </h6>
                                <ButtonRow />
                            </FlexCol>
                        )}
                        {!success && !userInfo?.isWebUser && (
                            <FlexCol>
                                <Input {...{
                                    label: 'First Name',
                                    value: request.firstName,
                                    onChange: (e) => setRequestItem('firstName', e.target.value)
                                }} />
                                <Input {...{
                                    label: 'Last Name',
                                    value: request.lastName,
                                    onChange: (e) => setRequestItem('lastName', e.target.value)
                                }} />
                                <Input {...{
                                    label: 'Company Name',
                                    value: request.companyName,
                                    onChange: (e) => setRequestItem('companyName', e.target.value)
                                }} />
                                <Input {...{
                                    label: 'Email',
                                    value: request.email,
                                    onChange: (e) => setRequestItem('email', e.target.value)
                                }} />
                                <Input {...{
                                    label: 'Phone',
                                    value: request.phone,
                                    type: 'phone',
                                    onChange: (e) => setRequestItem('phone', e.target.value)
                                }} />
                                <ButtonRow />
                            </FlexCol>
                        )}
                        {notificationMessage && <SpanError>{notificationMessage}</SpanError>}
                        {loading && <Loader />}
                    </FlexCol>
                </Modal>
            )}
        </div>
    )
}